import React from 'react';

interface IopDiagnosisTreatmentProps {
  intraocular_pressure: {
    od: number | null;
    oi: number | null;
    method: string;
    time: string;
  };
  diagnosis_oft: {
    primary: string;
    od_oi: string;
    icd10_code: string;
    type: string;
  };
  treatment_oft: {
    eye_drops: string;
    eye_drops_frequency: string;
    oral_medication: string;
    surgery_indicated: boolean;
    surgery_type: string;
    glasses_prescription: boolean;
    follow_up_days: number | null;
    observations: string;
  };
  onFieldChange: (section: string, field: string, value: any) => void;
}

const METHOD_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'soplosión', label: 'Soplosión' },
  { value: 'Goldmann', label: 'Goldmann' },
  { value: 'iCare', label: 'iCare' },
  { value: 'tonómetro de Schiötz', label: 'Tonómetro de Schiötz' },
];

const TIME_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'mañana', label: 'Mañana' },
  { value: 'tarde', label: 'Tarde' },
];

const OD_OI_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'ambos', label: 'Ambos' },
  { value: 'ojo derecho', label: 'Ojo Derecho' },
  { value: 'ojo izquierdo', label: 'Ojo Izquierdo' },
];

const TYPE_OPTIONS = [
  { value: '', label: 'Seleccionar...' },
  { value: 'emergencia', label: 'Emergencia' },
  { value: 'crónico', label: 'Crónico' },
  { value: 'agudo', label: 'Agudo' },
  { value: 'control', label: 'Control' },
];

const IopDiagnosisTreatment: React.FC<IopDiagnosisTreatmentProps> = ({
  intraocular_pressure: iop,
  diagnosis_oft: diagnosis,
  treatment_oft: treatment,
  onFieldChange,
}) => {
  return (
    <>
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="card-title">
            <i className="fa fa-tachometer me-1"></i>
            Presión Intraocular (PIO)
          </h5>
          <div className="row mt-3">
            <div className="col-md-3">
              <div className="mb-3">
                <label className="form-label">PIO OD (mmHg)</label>
                <input
                  type="number"
                  className="form-control"
                  min={0}
                  value={iop.od ?? ''}
                  onChange={e => onFieldChange('intraocular_pressure', 'od', e.target.value ? Number(e.target.value) : null)}
                  placeholder="10-21"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-3">
                <label className="form-label">PIO OI (mmHg)</label>
                <input
                  type="number"
                  className="form-control"
                  min={0}
                  value={iop.oi ?? ''}
                  onChange={e => onFieldChange('intraocular_pressure', 'oi', e.target.value ? Number(e.target.value) : null)}
                  placeholder="10-21"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-3">
                <label className="form-label">Método</label>
                <select
                  className="form-select"
                  value={iop.method}
                  onChange={e => onFieldChange('intraocular_pressure', 'method', e.target.value)}
                >
                  {METHOD_OPTIONS.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-3">
                <label className="form-label">Horario</label>
                <select
                  className="form-select"
                  value={iop.time}
                  onChange={e => onFieldChange('intraocular_pressure', 'time', e.target.value)}
                >
                  {TIME_OPTIONS.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <h5 className="card-title">
            <i className="fa fa-medkit me-1"></i>
            Diagnóstico
          </h5>
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Diagnóstico Principal</label>
                <input
                  type="text"
                  className="form-control"
                  value={diagnosis.primary}
                  onChange={e => onFieldChange('diagnosis_oft', 'primary', e.target.value)}
                  placeholder="Ej: Catarata, Glaucoma, Miopía..."
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-3">
                <label className="form-label">OD / OI / Ambos</label>
                <select
                  className="form-select"
                  value={diagnosis.od_oi}
                  onChange={e => onFieldChange('diagnosis_oft', 'od_oi', e.target.value)}
                >
                  {OD_OI_OPTIONS.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-3">
                <label className="form-label">Código CIE-10</label>
                <input
                  type="text"
                  className="form-control"
                  value={diagnosis.icd10_code}
                  onChange={e => onFieldChange('diagnosis_oft', 'icd10_code', e.target.value)}
                  placeholder="Ej: H25.9"
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="mb-3">
                <label className="form-label">Tipo</label>
                <select
                  className="form-select"
                  value={diagnosis.type}
                  onChange={e => onFieldChange('diagnosis_oft', 'type', e.target.value)}
                >
                  {TYPE_OPTIONS.map(o => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card mb-3">
        <div className="card-body">
          <h5 className="card-title">
            <i className="fa fa-file-lines me-1"></i>
            Tratamiento
          </h5>
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="mb-3">
                <label className="form-label">Gotas / Colirio</label>
                <input
                  type="text"
                  className="form-control"
                  value={treatment.eye_drops}
                  onChange={e => onFieldChange('treatment_oft', 'eye_drops', e.target.value)}
                  placeholder="Ej: Timolol, Latanoprost..."
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-3">
                <label className="form-label">Frecuencia Gotas</label>
                <input
                  type="text"
                  className="form-control"
                  value={treatment.eye_drops_frequency}
                  onChange={e => onFieldChange('treatment_oft', 'eye_drops_frequency', e.target.value)}
                  placeholder="Ej: Cada 12 horas"
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="mb-3">
                <label className="form-label">Medicación Oral</label>
                <input
                  type="text"
                  className="form-control"
                  value={treatment.oral_medication}
                  onChange={e => onFieldChange('treatment_oft', 'oral_medication', e.target.value)}
                  placeholder="Ej: Acetazolamida"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="surgery_indicated"
                    checked={treatment.surgery_indicated}
                    onChange={e => onFieldChange('treatment_oft', 'surgery_indicated', e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="surgery_indicated">
                    Cirugía Indicada
                  </label>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">Tipo de Cirugía</label>
                <input
                  type="text"
                  className="form-control"
                  value={treatment.surgery_type}
                  onChange={e => onFieldChange('treatment_oft', 'surgery_type', e.target.value)}
                  placeholder="Ej: Facoemulsificación, Trabeculectomía"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="glasses_prescription"
                    checked={treatment.glasses_prescription}
                    onChange={e => onFieldChange('treatment_oft', 'glasses_prescription', e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="glasses_prescription">
                    Prescripción de Lentes
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">Seguimiento (días)</label>
                <input
                  type="number"
                  className="form-control"
                  min={0}
                  value={treatment.follow_up_days ?? ''}
                  onChange={e => onFieldChange('treatment_oft', 'follow_up_days', e.target.value ? Number(e.target.value) : null)}
                  placeholder="Días"
                />
              </div>
            </div>
            <div className="col-md-8">
              <div className="mb-3">
                <label className="form-label">Observaciones</label>
                <textarea
                  className="form-control"
                  rows={2}
                  value={treatment.observations}
                  onChange={e => onFieldChange('treatment_oft', 'observations', e.target.value)}
                  placeholder="Notas adicionales del tratamiento..."
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IopDiagnosisTreatment;
